<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_v"></a>To my beloved Mother Grace Okri 1936–1996</h2>
<p class="poemtt">Now that serenely</p>
<p class="poem">You rest on high</p>
<p class="poem">Forgive your son</p>
<p class="poem">Who couldn’t say goodbye</p>
<p class="poemt">But Death was a tyrant</p>
<p class="poem">On the rich land</p>
<p class="poem">And you had written</p>
<p class="poem">Enigmas in my hand</p>
<p class="poemt">The more they try</p>
<p class="poem">To press you down</p>
<p class="poem">The more beautiful</p>
<p class="poem">Grows your crown</p>
<p class="poemt">And now that you</p>
<p class="poem">Are as a spiritual dove</p>
<p class="poem">Dwell forever</p>
<p class="poem">In our eternal love</p>
<a id="page_vi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Poem.vue?34af9baf